import React, { createRef, useEffect, useMemo, useState } from 'react';
import Header from '../../components/common/global-top-bar';
import { useDispatch, connect } from 'react-redux';
import Spinner from '../../components/common/spinner';
import { ROUTE_PATH } from '../../routes/paths';
import AlertBox from '../../components/route-leaving-prompt/alert-box';
import {
  fetchResourceRequest,
  fetchResourceSuccess,
  postResourcesRequest,
  postResourcesSuccess,
  removeResourcesRequest,
  removeResourcesSuccess,
  updateResourcesRequest,
} from './redux-resources/actions';
import { CustomInput, UseFormDropDown, UseFormToggle } from '../../components/common';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router';
import { decimalOnChange, numberonBlur, onBlur } from '../../components/common/useForm';
import HeadBack from '../clients/redirect';
import { toast } from 'react-toastify';
import { ToggleButton } from '../../components/common';

type props = {
  resources: any;
  pending: any;
  newResource: any;
  removeResources: any;
};

const ResourceListing: React.FunctionComponent<props> = (props): JSX.Element => {
  const [isShowAlertmodel, setIsShowAlertModel] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const search = useLocation().search;
  const resourceId = new URLSearchParams(search).get('resource-id');
  const fileInput: any = createRef();
  const [image, setimgPreview] = useState<any>();
  const [enableSaveOption, setenableSaveOption] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(postResourcesSuccess({ Resources: {} }));
      dispatch(removeResourcesSuccess({ RemoveResources: {} }));
      dispatch(fetchResourceSuccess({ resource: {} }));
    };
  }, []);

  useEffect(() => {
    if (resourceId && resourceId !== 'new') {
      dispatch(
        fetchResourceRequest({
          id: resourceId,
        }),
      );
    }
  }, [resourceId]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: useMemo(() => {
      if (props.resources && resourceId) {
        const resource = props.resources;
        return {
          description: resource?.description || '',
          image_url: resource?.image_url || null,
          name: resource?.name || '',
          phone_number: resource?.phone_number || '',
          sort_weight: resource?.sort_weight || 0,
          status: resource?.status || 'live',
          url: resource?.url || '',
        };
      }
    }, [props, resourceId]),
  });

  useEffect(() => {
    if (resourceId) {
      const resource = props.resources;
      reset({
        description: resource?.description || '',
        image_url: resource?.image_url || null,
        name: resource?.name || '',
        phone_number: resource?.phone_number || '',
        sort_weight: resource?.sort_weight || 0,
        status: resource?.status || 'live',
        url: resource?.url || '',
      });
      setimgPreview(resource?.image_url || null);
      setenableSaveOption(false);
    }
  }, [props.resources]);

  const onSubmit = (data: any) => {
    const payload = {
      ...data,
      image_url: data?.image_url ? (enableSaveOption ? data?.image_url : undefined) : null,
    };
    if (resourceId === 'new') {
      dispatch(postResourcesRequest(payload));
    } else {
      dispatch(updateResourcesRequest({ id: resourceId, payload }));
    }
  };

  const handleDelete = () => {
    dispatch(removeResourcesRequest({ id: resourceId }));
    setIsShowAlertModel(false);
  };

  const onFileChange = async (event: any) => {
    try {
      if (event.target.files && event.target.files[0]) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          const image = new Image();
          image.src = e.target.result;

          //Validate the File Height and Width.
          image.onload = () => {
            // @ts-ignore
            const height = image.height;
            // @ts-ignore
            const width = image.width;
            if (height === width) {
              setimgPreview(image.src);
              setValue('image_url', image.src);
              setenableSaveOption(true);
            } else {
              toast.error('Image must be equal height and width.');
              return new Error('Image must be equal height and width.');
            }
          };
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    } catch (error) {
      console.error('err--', error);
    }
  };
  const hadleImageinput = (e: any) => {
    fileInput.current.click();
  };

  useEffect(() => {
    if (props.removeResources) {
      history.push(ROUTE_PATH.RESOURCES);
    }
  }, [props.removeResources]);

  useEffect(() => {
    if (props.newResource) {
      history.push(ROUTE_PATH.RESOURCES);
    }
  }, [props.newResource]);

  return (
    <div>
      <Header
        heading={
          <HeadBack
            clientName={resourceId === 'new' ? 'Resources' : props.resources?.name || ''}
            headback={ROUTE_PATH.RESOURCES}
          />
        }
      />
      <div className="bg-gray-background-light flex h-10 items-center justify-end px-7">
        <div className="flex">
          {' '}
          {resourceId !== 'new' && (
            <button
              className="bg-blue-primary h-6 w-20 rounded-full px-2 text-center text-sm text-white"
              onClick={() => {
                setIsShowAlertModel(true);
              }}
            >
              REMOVE
            </button>
          )}
          <div className={` ${!isDirty && !enableSaveOption && 'cursor-not-allowed'}`}>
            <button
              className={`ml-2 h-6 w-20 rounded-full px-2 text-center text-sm text-white ${
                isDirty || enableSaveOption ? 'bg-bright-blue' : 'bg-gray-background-dark pointer-events-none'
              }`}
              type="submit"
              form="member-profile-form"
            >
              SAVE
            </button>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} id="member-profile-form">
        <div className="max-window-height overflow-y-auto pb-10">
          <div className="w-full px-3">
            {props.pending ? (
              <Spinner />
            ) : (
              <div className="mx-7 mt-5 grid w-3/4 grid-cols-2 gap-x-6 gap-y-6">
                <CustomInput
                  inputType="text"
                  Label="Resource name"
                  register={{
                    ...register('name', {
                      required: 'Please provide resource name',
                      onBlur: (e: any) => onBlur(e, 'name', setValue),
                    }),
                  }}
                  //@ts-ignore
                  Error={!!errors?.name?.message?.length}
                  ErrorMessage={errors.name?.message}
                  dataTestId="resource-name"
                />

                <UseFormDropDown label={'Status'}>
                  <select
                    className="select-box w-full focus:ring-transparent"
                    defaultValue="published"
                    {...register('status')}
                    data-testid="resource-listing-status"
                  >
                    <option value="live">Live</option>
                    <option value="hidden">Hidden</option>
                  </select>
                </UseFormDropDown>
                <div>
                  <h3 className="text-blue-dark mb-2 block text-sm leading-4">Description</h3>

                  <div className="my-2 w-full">
                    <textarea
                      data-testid="resource-listing-description"
                      className="text-gray-dark bg-gray-background-light h-28 w-full rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:outline-none"
                      {...register('description', {
                        required: 'Please provide resource description',
                        onBlur: (e: any) => onBlur(e, 'description', setValue),
                      })}
                    />
                    {
                      //@ts-ignore
                      !!errors?.description?.message?.length > 0 && (
                        <label className="text-red mb-2 block pt-2 text-xs font-medium leading-4">
                          {/* @ts-ignore */}
                          {errors.description?.message}
                        </label>
                      )
                    }
                  </div>
                </div>

                <CustomInput
                  inputType="text"
                  Label="Sort Order"
                  register={{
                    ...register('sort_weight', {
                      onChange: (e) => decimalOnChange(e, 'sort_weight', setValue, 2),
                      onBlur: (e) => numberonBlur(e, 'sort_weight', setValue),
                      valueAsNumber: true,
                    }),
                  }}
                  //@ts-ignore
                  Error={!!errors?.sort_weight?.message?.length}
                  ErrorMessage={errors.sort_weight?.message}
                  dataTestId="resource-sort-order"
                />
                <div className="flex flex-col space-y-6">
                  <CustomInput
                    inputType="text"
                    Label="Link"
                    register={{
                      ...register('url', {
                        required: 'Please provide resource description',
                        onBlur: (e: any) => onBlur(e, 'url', setValue),
                      }),
                    }}
                    //@ts-ignore
                    Error={!!errors?.url?.message?.length}
                    ErrorMessage={errors.url?.message}
                    dataTestId="resource-link"
                  />
                  <CustomInput
                    inputType="text"
                    Label="Phone "
                    register={{
                      ...register('phone_number', {
                        onBlur: (e: any) => onBlur(e, 'phone_number', setValue),
                      }),
                    }}
                    //@ts-ignore
                    Error={!!errors?.phone_number?.message?.length}
                    ErrorMessage={errors.phone_number?.message}
                    dataTestId="resource-phone-number"
                  />
                </div>
                <div className="w-full">
                  <label className={`text-gray-dark mb-2 block leading-4`}>Resource Image</label>
                  <div className="flex w-full">
                    <div
                      className="aspect-ratio-container flex w-full cursor-pointer items-center justify-center rounded-sm bg-gray-200"
                      onClick={hadleImageinput}
                      data-testid="resource-listing-image-upload"
                    >
                      {image ? (
                        <img className="h-full w-full" src={image} alt="clinetImage" />
                      ) : (
                        <div className="flex h-56 items-center justify-center">
                          <button
                            className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-3xl"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                          >
                            +
                          </button>
                          <input
                            ref={fileInput}
                            id="file-upload"
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onClick={() => {
                              fileInput.current.value = null;
                            }}
                            onChange={(data) => {
                              onFileChange(data);
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="pl-6">
                      {image && (
                        <button
                          className="my-2 w-full rounded-full bg-gray-300 p-2 text-center text-sm text-white"
                          onClick={() => {
                            setimgPreview(null);
                            setValue('image_url', null);
                            setenableSaveOption(true);
                          }}
                          data-testid="resource-listing-remove-resource-image"
                        >
                          REMOVE
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
      <AlertBox
        visible={isShowAlertmodel}
        handlePrompt={handleDelete}
        closeModal={() => setIsShowAlertModel(false)}
        titleText={'Alert'}
        contentText={`Are you sure you want to remove ${getValues('name')}?`}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Remove'}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    resources: state.resources.resource?.data || null,
    newResource: state.resources.newResource?.data || null, //
    removeResources: state.resources.RemoveResources?.data || null, //
    pending: state.resources?.pending || null,
  };
};

export default connect(mapStateToProps)(ResourceListing);
